module.exports = __webpack_public_path__ + "img/lang-latest.19c5e60a.png";